import { ENV } from 'shared/ENV';

export const EXTERNAL_DATA_WATCHDUTY_ORGANIZATION_ID = 1;
const EXTERNAL_DATA_PUBLIC_TILESET_NAME = 'external_data_public';

export const getWatchdutyTileUrl = (name: string): string => {
  return `${ENV.VITE_TILE_SERVER_URL}${name}`;
};

export const getWatchdutyExternalDataPublicTileUrl = (
  organization_id: number,
  short_name: string,
): string => {
  return `${ENV.VITE_TILE_SERVER_URL}${EXTERNAL_DATA_PUBLIC_TILESET_NAME}?organization_id=${organization_id}&layer_short_name=${short_name}`;
};
